module.exports = __webpack_public_path__ + "img/jjh.78801ecd.png";